import cx from 'classnames';
import * as React from 'react';
import { Box } from '../../utils/index.js';
export const Text = React.forwardRef((props, ref) => {
  let {
    variant = 'body',
    className,
    isMuted = false,
    isSkeleton = false,
    ...rest
  } = props;
  return React.createElement(
    TextContext.Provider,
    {
      value: true,
    },
    React.createElement(Box, {
      className: cx(
        {
          [`iui-text-${variant}`]: 'body' !== variant,
          'iui-text-block': 'body' === variant,
          'iui-text-muted': isMuted,
          'iui-skeleton': isSkeleton,
        },
        className,
      ),
      ref: ref,
      ...rest,
    }),
  );
});
Text.displayName = 'Text';
export const TextContext = React.createContext(false);
